import { isUndefined } from 'lodash'

const TitleColumnFramework = ({ value }) => {
  const MAX_CHARS = 30
  return !isUndefined(value) && value.length > MAX_CHARS
    ? `${value.substring(0, MAX_CHARS)}...`
    : value ?? ' '
}

export default TitleColumnFramework
